import React from 'react';
import type { ItemSidebarComponentFeatureType } from '../types';
import { ServerSideZones } from '../../../ads/types';
import { SponsoFactoryWrapper } from './ProgrammableComponent';

const FeatureProgrammableComponent: React.FC<ItemSidebarComponentFeatureType> = ({ data }) => {
  // @ts-ignore
  const config: ServerSideZones = data.data?.data?.config;

  if (config?.zoneSlug) {
    return <SponsoFactoryWrapper config={config} />;
  }

  return null;
};

export default FeatureProgrammableComponent;
